import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { CiiuActivity } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useLanguage } from "../../../../contexts";

const ctrl = new CiiuActivity();

const INPUT_STYLE = {
  width: "100%", padding: "10px 14px", border: "1px solid #D1D5DB",
  borderRadius: "6px", fontSize: "0.95rem", outline: "none",
  boxSizing: "border-box", fontFamily: "'Archivo', sans-serif",
};
const LABEL_STYLE = {
  display: "block", fontWeight: 600, marginBottom: "0.35rem",
  fontSize: "0.875rem", color: "#374151",
};
const BTN_BASE = {
  border: "none", borderRadius: "20px", padding: "10px 30px",
  fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer",
};

export function CiiuActivityForm({ item, close, onReload }) {
  const { accessToken } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const formik = useFormik({
    initialValues: { code: item?.code || "", name: item?.name || "" },
    validationSchema: Yup.object({
      code: Yup.string().required("El código es requerido"),
      name: Yup.string().required("La descripción es requerida"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const payload = { code: values.code.toUpperCase().trim(), name: values.name.trim() };
        if (item) {
          await ctrl.updateCiiuActivity(accessToken, item._id, payload);
          toast.success("Actualizado");
        } else {
          await ctrl.createCiiuActivity(accessToken, payload);
          toast.success("Creado");
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || "Error al guardar");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />

      <div style={{ marginBottom: "1.2rem" }}>
        <label style={LABEL_STYLE}>
          {t("ciiu_code")} <span style={{ color: "#C0392B" }}>*</span>
        </label>
        <input
          name="code"
          type="text"
          value={formik.values.code}
          autoFocus
          onChange={(e) => formik.setFieldValue("code", e.target.value.toUpperCase())}
          placeholder="Ej: 14"
          style={{ ...INPUT_STYLE, borderColor: formik.errors.code ? "#C0392B" : "#D1D5DB" }}
        />
        {formik.errors.code && (
          <p style={{ color: "#C0392B", fontSize: "0.8rem", margin: "0.25rem 0 0" }}>{formik.errors.code}</p>
        )}
      </div>

      <div style={{ marginBottom: "1.2rem" }}>
        <label style={LABEL_STYLE}>
          {t("description")} <span style={{ color: "#C0392B" }}>*</span>
        </label>
        <input
          name="name"
          type="text"
          value={formik.values.name}
          onChange={(e) => {
            const v = e.target.value;
            formik.setFieldValue("name", v ? v.charAt(0).toUpperCase() + v.slice(1) : v);
          }}
          placeholder="Ej: Confección de prendas de vestir"
          style={{ ...INPUT_STYLE, borderColor: formik.errors.name ? "#C0392B" : "#D1D5DB" }}
        />
        {formik.errors.name && (
          <p style={{ color: "#C0392B", fontSize: "0.8rem", margin: "0.25rem 0 0" }}>{formik.errors.name}</p>
        )}
      </div>

      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        <button
          type="submit"
          disabled={formik.isSubmitting}
          style={{ ...BTN_BASE, background: "#4A7FA5", color: "#fff", opacity: formik.isSubmitting ? 0.55 : 1 }}
        >
          {formik.isSubmitting ? "…" : (item ? t("update") : t("save"))}
        </button>
        <button
          type="button"
          onClick={close}
          style={{ ...BTN_BASE, background: "#9BAFC4", color: "#fff" }}
        >
          {t("cancel")}
        </button>
      </div>
    </form>
  );
}
